/* @jsx h */
import { defineComponent, defineAsyncComponent, h, ref, onMounted } from "vue";
import { api } from "@app/data/api";
import { Loading } from "@lemmonhq/uikit";
import type { Product, Service, FoodType, Extra } from "@lemmonhq/types";

const ProductsViewV2Component = defineAsyncComponent(async () => {
  const module = await import("./ProductsViewV2");
  return module.ProductsViewV2;
});

export const ProductsSubPageV2 = defineComponent({
  name: "ProductsSubPageV2",
  setup() {
    const products = ref<Product[]>([]);
    const services = ref<Service[]>([]);
    const foodTypes = ref<FoodType[]>([]);
    const extras = ref<Extra[]>([]);
    const loading = ref(true);

    const loadAll = async () => {
      const [fetchedProducts, fetchedServices, fetchedFoodTypes, fetchedExtras] =
        await Promise.all([
          api.getProducts(),
          api.getServices(),
          api.getFoodTypes(),
          api.getExtras(),
        ]);
      products.value = fetchedProducts;
      services.value = fetchedServices;
      foodTypes.value = fetchedFoodTypes;
      extras.value = fetchedExtras;
    };

    onMounted(async () => {
      try {
        await loadAll();
      } catch (error) {
        console.error("Failed to fetch products data:", error);
      } finally {
        loading.value = false;
      }
    });

    return () => {
      if (loading.value) {
        return h(
          "div",
          { class: "w-full h-full flex justify-center items-center" },
          [h(Loading)],
        );
      }

      return h(ProductsViewV2Component, {
        products,
        services,
        foodTypes,
        extras,
        onReload: loadAll,
      });
    };
  },
});
